export default "* Tørt mos, kviste og pinde\n* Brænde\n* Ildstål eller tændstikker\n* Spand med vand\n* Evt. brændekløver ”Kindling Cracker”";